import { useQuery } from '@apollo/client'
import { GET_ORGANIZATION } from 'constants/queries'
import { Organization } from 'types/generatedGql'
import useSubdomain from './useSubdomain'

export const useGetOrganization = () => {
  const { hasSubDomain, subDomain } = useSubdomain()
  const { data, loading, error } = useQuery<{ getOrganization: Organization }>(GET_ORGANIZATION, {
    variables: { subdomain: subDomain },
    skip: !hasSubDomain || !subDomain,
    fetchPolicy: 'cache-first',
  })

  return { loading, error, organization: data?.getOrganization, subDomain, hasSubDomain }
}
